import {FETCH_SPECIALITY} from "./index" 

export const setSpecialityOption = (payload) => {
    return {
      type: FETCH_SPECIALITY,
      payload: payload
    };
  };